// extracted by mini-css-extract-plugin
export default {"header":"style_header__Km1YB","timeBox":"style_timeBox__TcR3P","mapAndStatusBox":"style_mapAndStatusBox__r-HP+","mapBox":"style_mapBox__Cu089","statusBox":"style_statusBox__poe+S"};